

import React from 'react';
import withStyles from '@mui/styles/withStyles';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
//import { withTranslation } from 'react-i18next';
import styles from '../styles';



function PagerFooter(props) {

    return (
        <Box>
            <Box pb={3} mt={4} mb={4} borderColor="#E0E0E0">
                <Grid container spacing={2} justifyContent="flex-end">
                    {props.actionButtons && props.actionButtons.map((button) => (
                        <Grid item key={button.label}>
                            <Button
                                variant="contained"
                                color="primary"
                                className={[].join(' ')}
                                onClick={button.action || undefined}
                                type={("action" in button) ? "" : "submit"}
                                disabled={button.disabled || false}
                            >
                                {button.label}
                            </Button>
                        </Grid>
                    ))}
                </Grid>
            </Box>
           
        </Box>
    );
}

export default withStyles(styles, { withTheme: true })(PagerFooter);